import { render, staticRenderFns } from "./ShopBindVd.vue?vue&type=template&id=e83c4920&scoped=true"
import script from "./ShopBindVd.vue?vue&type=script&lang=ts"
export * from "./ShopBindVd.vue?vue&type=script&lang=ts"
import style0 from "./ShopBindVd.vue?vue&type=style&index=0&id=e83c4920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83c4920",
  null
  
)

export default component.exports